import { CreateDocument } from './CreateDocument'

export default CreateDocument
